import styled from "@emotion/styled";

const Label = styled("label")`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
`;

export const LabelT1 = styled(Label)`
  color: #fff;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
export const LabelT2 = styled(Label)`
  color: #528aea;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
`;
export const LabelT3 = styled(Label)`
  color: #1d2646;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
`;

export const LabelT4 = styled(LabelT2)`
  color: #fff;
`;
export const LabelT5 = styled(LabelT1)`
  font-size: 16px;
  line-height: 18px;
`;

export const LabelT6 = styled(Label)`
  color: #191919;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`;
export const LabelT7 = styled(Label)`
  color: #191919;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
